import { InstrumentStoreItem, Loadable, LoadableState } from '@eih-netbroker/common';
import { atom, WritableAtom } from 'jotai';
import { atomFamily } from 'jotai/utils';

export type ProductDetailsBase = {
  instrumentStoreItem: Partial<InstrumentStoreItem>;
  lastPrice: string;
  lastPriceTime: string;
  previousLastPrice?: string;
  openPrice: string;
  low: string;
  lowNumber?: number;
  high: string;
  highNumber?: number;
  newHighOrLowFlag: boolean;
  averagePrice: string;
  volumeQuantity: string;
  volumeValue: string;
  annualLow: string;
  annualHigh: string;
  annualLowDate: string;
  annualHighDate: string;
  closePrice: string;
  dailyChange: string;
  dailyChangePercent: string;
  YTDChangePercent: string;
  marketCapitalization: string;
  earningsPerShareTTM: string;
  priceToBookValue: string;
  priceToEarningsTTM: string;
  priceToSalesTTM: string;
  dividend: string;
  dividendYield: string;
  dividendYield5Years: string;
  EBITDA: string;
  ROE: string;
  ROA: string;
  tenDayAverageVolume: string;
};

export type ProductDetailsBaseMaybe = LoadableState<ProductDetailsBase>;

export const productDetailstStateAtom = atomFamily<string, WritableAtom<ProductDetailsBaseMaybe, any, any>>(_id =>
  atom(Loadable.uninitialized),
);
